import { Help } from '@plasma/ui.application.app';

const help: Help[] = [
  // {
  //   title: 'RoleBaseDesign',
  //   description: 'description of RoleBaseDesign',
  //   url: '/role-base-design',
  // },
];

export default help;
